module.exports = __webpack_public_path__ + "img/07-mobile.b5ded064.jpg";